type SignUpFinalizeCapable = {
  finalize: (params?: {
    navigate?: (params: { decorateUrl: (url: string) => string }) => void | Promise<void>;
  }) => Promise<{ error: unknown }>;
};

/**
 * Complete a Clerk sign-up and navigate to the post-registration destination.
 */
export async function finalizeClerkSignUp(
  signUp: SignUpFinalizeCapable,
  destination: string,
  navigateApp: (path: string) => void,
): Promise<void> {
  await signUp.finalize({
    navigate: async ({ decorateUrl }) => {
      const url = decorateUrl(destination);
      if (url.startsWith('http')) {
        window.location.href = url;
        return;
      }
      navigateApp(url);
    },
  });
}
